import {AfterViewInit, Component, ElementRef, HostListener, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {Observable, Subscriber} from 'rxjs';
import Modal from 'bootstrap/js/dist/modal';
import {ConfirmService} from '../../../services/confirm/confirm.service';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements AfterViewInit {

  @ViewChild('confirm') confirmElement!: ElementRef;

  modal: Modal | null = null;
  subscriber: Subscriber<boolean> | null = null;
  message: string = '';
  result: boolean = false;

  constructor(private el: ElementRef, private confirm: ConfirmService) {
    this.confirm.setComponent(this);
  }

  ngAfterViewInit(): void {
    this.confirmElement.nativeElement.addEventListener('hidden.bs.modal', () => {
      this.subscriber?.next(this.result);
      this.result = false;

      // const body = document.querySelector('body');
      // if (body) {
      //   body.style.position = 'static';
      // }
    });
  }

  open(question: string): Observable<boolean> {
    this.message = question;

    return new Observable<boolean>((subscriber: Subscriber<boolean>) => {
      // const body = document.querySelector('body');
      // if (body) {
      //   body.style.position = 'fixed';
      // }

      const element = this.el.nativeElement;
      const modalElement = element.querySelector('.modal');
      this.modal = new Modal(modalElement, {backdrop: true});
      this.subscriber = subscriber;
      this.modal?.show();
    });
  }

  close(result: boolean = false): void {
    this.result = result;
    this.modal?.hide();
  }

  @HostListener('document:keydown.escape')
  escape(): void {
    this.close(false);
  }

  @HostListener('document:keydown.enter')
  enter(): void {
    this.close(true);
  }

}
